import { fetchWithAuth } from '../AuthService';
import { AI_SERVICE_BASE_URL } from '../AiApiService';

/**
 * AI Health API service - Health checks and service monitoring
 */
export const AiHealthApi = {
  /**
   * Health check for the AI service (requires authentication)
   * @returns {Promise<Response>} Health check response
   */
  checkHealth: async () => {
    return fetchWithAuth(`${AI_SERVICE_BASE_URL}/util/health`, {
      method: 'GET',
    });
  },

  /**
   * Check if service is available
   * @returns {Promise<boolean>} Service availability
   */
  isServiceAvailable: async () => {
    try {
      const response = await AiHealthApi.checkHealth();
      return response.ok;
    } catch (error) {
      console.error('AI Service health check failed:', error);
      return false;
    }
  },

  /**
   * Get service info from health check
   * @returns {Promise<Object|null>} Service info or null if unavailable
   */
  getServiceInfo: async () => {
    try {
      const response = await AiHealthApi.checkHealth();
      if (response.ok) {
        return await response.json();
      }
      return null;
    } catch (error) {
      console.error('Failed to get service info:', error);
      return null;
    }
  },

  /**
   * Get base URL for the AI service
   * @returns {string} Base URL
   */
  getBaseUrl: () => AI_SERVICE_BASE_URL,
};